import style from "./reset-password.module.css";
import React from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from 'react-router-dom';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import userService from '../../services/user-service';
import { Form, Input, Button, Row, Col } from "antd";

import * as Icon from "react-feather";

const ResetPassword = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  // const token = StorageUtils.getToken();
  let { token } = useParams();
  const [form] = Form.useForm();

  const onSubmit = async () => {
    try {
      const values = await form.validateFields();
      try {
        dispatch(appLoaderAction.enable());
        let bean = {
          //TODO
          resetToken: token,
          newPassword: values.newPassword
        }
        await userService.resetPassword(bean);
        notifyUtitls.success('สำเร็จ', 'เปลี่ยนรหัสสำเร็จ');
        history.replace('/');
        dispatch(appLoaderAction.disale());
      } catch (err) {
        notifyUtitls.error(err);
        dispatch(appLoaderAction.disale());
      }
    } catch (error) {
			notifyUtitls.warning('แจ้งเตือน', 'โปรดระบุข้อมูลให้ครบถ้วน');
    }
  }

  return (
    <div className="bg-gray">
      <div className="container h-100">
        <Row className="center-screen">
          <Col xs={24} sm={24} md={18} lg={14} xl={14}>
            <div className={style.content_forgotpass}>
              <Row>
                {/* <Col xs={0} sm={0} md={0} lg={8} xl={10}>
                  <div className={style.bg_forgotpass}>
                    <img src="/assets/icon-lock.png" style={{height:"140"}}  />
                  </div>
                </Col> */}
                <Col span={24}>
                  <div className={style.login_detail}>
                    <div className={style.bg_forgotpass}>
                      <img
                        src="/assets/icon-lock.png"
                        style={{ height: "140" }}
                      />
                    </div>
                    <h3 style={{ fontWeight: "400" }}>ตั้งรหัสผ่านใหม่</h3>
                    <p>คุณสามารถกรอกรหัสผ่านใหม่</p>
                    <Form
                      form={form}
                      name="basic"
                      layout="vertical"
                      className="my-3"
                      labelCol={{
                        span: 24,
                      }}
                      wrapperCol={{
                        span: 24,
                      }}
                    >
                      <Form.Item
                        label={<div className="d-flex"> New Password </div>}
                        name="newPassword"
                        rules={[
                          {
                              required: true,
                          },
                        ]}
                      >
                        {/* <Input className="w-100" name="New Password"  /> */}
                        <Input.Password  name="New Password" />
                      </Form.Item>
                      <Form.Item
                        label={<div className="d-flex"> Confirm New Password </div>}
                        name="confirmPassword"
                        dependencies={['newPassword']}
                        rules={[
                          {
                              required: true,
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value || getFieldValue('newPassword') === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error('The two passwords that you entered do not match!'));
                            },
                          }),
                        ]}
                      >
                        {/* <Input className="w-100" name="New Password"  /> */}
                        <Input.Password name="New Password" />
                      </Form.Item>
                      <Button key="submit" type="primary" className="w-100" onClick={onSubmit}>
                        <Icon.Save className="me-2" size={17} /> บันทึก
                      </Button>

                      {/* <div className="d-flex  align-items-center">
                        <span className="me-1 text-gray ">Login with</span> <div className="button-google"><img src="/assets/google-icon.jpg" className="img-fluid" /></div>
                      </div> */}
                    </Form>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ResetPassword;
